export default function __(key, replace) {
  let translation;

  try {
    translation = key
      .split('.')
      .reduce((t, i) => t[i] || null, window.room_rent.translations);

    if (translation && replace) {
      for (let [key, value] of Object.entries(replace)) {
        translation = translation.replace('{' + key + '}', value);
      }
    }

    if (!translation) {
      translation = key;
    }
  } catch (e) {
    translation = key;
  }

  return translation;
}
